import { Injectable } from '@angular/core'; 
import { environment } from '../../environments/environment';

import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpClient, HttpRequest, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';



@Injectable()
export class ApiService {

public baseUrl: string; // = environment.urlToApi;

private _tokenKey = "token";

  constructor(private http: HttpClient
) { }

        public get<T>(url: string, payload: string): Observable<T>  {
            return this.go<T>(url, "GET", payload);
        }

        public post<T>(url: string, payload: any, headers: HttpHeaders = null): Observable<T>  {
            return this.go<T>(url, "POST", payload, headers);
        }

        private go<T>(url: string, method: string, payload: any, headers: HttpHeaders = null): Observable<T> {
            if (url === '') { window.alert('No URL provided for API call'); }

            url = this.baseUrl + url;
   
            const options = new HttpRequest(method, url, payload, {headers: headers});  
  
            this.addToken(options);

            console.log(url, options);

            var promiseResult = this.http.request(method, url, options)
                  .map((res) => this.successCallback(res))
                  //.catch((err) => this.errorCallback(err))
                  .pipe(catchError(this.handleError));

            return promiseResult;
        }

          private successCallback(response: Response | any): any {
              console.log("API success", response);

              /*
              if (response instanceof Response) {
                return response.json();
              }
*/

              if (response) {
                return response;
              } else {
                return null;
              }
          }

          private errorCallback(err: Response | any): any {
            if (err instanceof Response) {

              if (err.status === 401) {

                var token = this.logOut();

              } else if (err.status === 403) {

                if (err.headers.has("lapierror")) {
                  var lapierror = err.headers.get("lapierror");
                  console.log(lapierror);
                }

              }

              return Observable.throw(err || "error2");

            }
            return Observable.throw(err || "error3");
          }

          private handleError(error: HttpErrorResponse) {

            if (error.error instanceof ErrorEvent) {
              // A client-side or network error occurred. Handle it accordingly.
              console.error('An error occurred:', error.error.message);
            } 
            else {
              // The backend returned an unsuccessful response code. 
              console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);

              if (error.status == 400) {
                return throwError(error.error);
              }
            }
            // return an observable with a user-facing error message
            return throwError('There was an error with the API; please try again later.');

          };

          private addToken(httpOptions: any) {

              // Append the token header
              var token = this.getToken();

              if (token !== "") {

                if (httpOptions.headers === null) {
                  httpOptions.headers = new HttpHeaders();
                }

                var value = "Bearer " + token;
                httpOptions.headers = httpOptions.headers.set("Authorization", value);

              }

          }

          public getToken(): string {
            return localStorage.getItem(this._tokenKey);
          }


          public setToken(value: string) {
            localStorage.setItem(this._tokenKey, value);
          }

          public assignBaseUrlToLocalStorage() {
            //Set the baseUrl in localstorage. There is a static HTML file that will call the URL to display the Proper HTML document
            
            if (this.baseUrl == "" || this.baseUrl == undefined) {
              alert("Cannot set the API url, the baseURL is not specified");
            }

            console.log("Setting the base url to localStorage", this.baseUrl);
            localStorage.setItem("baseUrlToApi", this.baseUrl);
          }


  public logOut() {
    localStorage.clear();
  }



}

